const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

export function demoConfigured() {
  return Boolean(url && key);
}

export async function submitDemoRequest(fields) {
  if (!demoConfigured()) {
    return { ok: false, error: "Demo requests are not connected. Set the public Supabase URL and anon key, and deploy the request-demo function." };
  }
  const details = [
    fields.message,
    fields.job_title && `Job title: ${fields.job_title}`,
    fields.phone && `Phone: ${fields.phone}`,
    fields.country && `Country: ${fields.country}`,
    fields.industry && `Industry: ${fields.industry}`,
    fields.sites && `Number of sites: ${fields.sites}`,
  ].filter(Boolean).join("\n");
  const response = await fetch(`${url}/functions/v1/request-demo`, {
    method: "POST",
    headers: { "Content-Type": "application/json", apikey: key },
    body: JSON.stringify({
      full_name: fields.full_name,
      email: fields.email,
      company: fields.company,
      message: details,
    }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) return { ok: false, error: body.error || "The request was not stored." };
  return { ok: true, message: body.message || "Request stored." };
}
